import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Trophy, Gift, Zap, ArrowRight } from "lucide-react";

const MEDAL = ["🥇", "🥈", "🥉"];

export default function ReferralLeaderboard() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/referrals/leaderboard?limit=8")
      .then(({ data }) => setRows(data.leaderboard || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 md:py-20" data-testid="referral-leaderboard">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
        <div>
          <div className="chip !text-lime !border-lime/40 mb-3"><Trophy className="w-3 h-3" /> Referral Leaderboard</div>
          <h2 className="font-fancy text-3xl sm:text-4xl md:text-5xl leading-[0.95]">Top inviters<br className="hidden md:block" /> <span className="grad-text-hot">this month.</span></h2>
        </div>
        <p className="text-sm text-muted md:max-w-sm md:text-right">Bring friends, climb the board. Top 3 every month get free VIP + ticket vouchers. Your first 2 invites = a free ticket.</p>
      </div>

      <div className="grid md:grid-cols-[2fr_1fr] gap-6" data-testid="referral-leaderboard-grid">
        {/* Leaderboard */}
        <div className="glass rounded-3xl overflow-hidden">
          {loading ? (
            <div className="p-6 font-mono text-sm text-muted">Loading leaderboard…</div>
          ) : rows.length === 0 ? (
            <div className="p-8 text-center">
              <Trophy className="w-10 h-10 text-lime mx-auto mb-3" />
              <div className="font-heading font-bold text-lg">Be the first to top the board.</div>
              <div className="text-sm text-muted mt-1">No referrals yet — invite 2 friends and you're on the map.</div>
            </div>
          ) : (
            <div>
              {rows.map((r, i) => (
                <div key={r.user_id || i} data-testid={`leaderboard-row-${r.rank}`}
                  className={`flex items-center gap-4 px-4 py-3 border-b border-white/5 ${i < 3 ? "bg-gradient-to-r from-lime/5 to-transparent" : ""}`}>
                  <div className="w-10 text-center">
                    {i < 3 ? <span className="text-2xl">{MEDAL[i]}</span> : <span className="font-mono text-sm text-muted">#{r.rank}</span>}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-heading font-bold truncate">{r.display_name || "Eventom Fan"}</div>
                    {r.city && <div className="text-[10px] font-mono uppercase tracking-widest text-muted">{r.city}</div>}
                  </div>
                  <div className="text-right">
                    <div className="font-fancy text-2xl leading-none" style={{ color: i === 0 ? "#D4FF00" : i === 1 ? "#FF2E9A" : i === 2 ? "#7B2FFF" : "#F5F5F7" }}>{r.conversions}</div>
                    <div className="text-[9px] font-mono uppercase tracking-widest text-muted">invites</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Perks column */}
        <div className="glass rounded-3xl p-6 flex flex-col justify-between" style={{ background: "linear-gradient(140deg, rgba(212,255,0,0.08), rgba(255,46,154,0.08))" }}>
          <div>
            <Gift className="w-8 h-8 text-lime mb-3" />
            <div className="font-display uppercase text-2xl leading-tight">How the perks work</div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex gap-2"><Zap className="w-4 h-4 text-lime shrink-0 mt-0.5" /><span><b className="text-lime">2 friends</b> join = 1 free ticket voucher</span></li>
              <li className="flex gap-2"><Zap className="w-4 h-4 text-magenta shrink-0 mt-0.5" /><span><b className="text-magenta">Top 3 this month</b> get free VIP</span></li>
              <li className="flex gap-2"><Zap className="w-4 h-4 text-skyx shrink-0 mt-0.5" /><span>Every friend who books = <b className="text-skyx">100 loyalty points</b> (₹10 off)</span></li>
            </ul>
          </div>
          <Link to="/profile#refer" data-testid="leaderboard-cta" className="btn-primary justify-center mt-6">
            Get my referral link <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
